import { TrackJS } from "trackjs-nextjs"

import { SANDBOX, TRACKJS_TOKEN } from "./config"
import { QUOTE_ID_KEY } from "./storage"

if (!SANDBOX && typeof window !== "undefined" && !TrackJS.isInstalled()) {
  TrackJS.install({
    token: TRACKJS_TOKEN,
    application: "germany",
    network: { error: false },
    // for more configuration options, see https://docs.trackjs.com
  })
}

export function addQuoteIdToTrackJS(quoteId: string | undefined) {
  try {
    TrackJS?.addMetadata(QUOTE_ID_KEY, quoteId || "no quote id")
  } catch {}
}
